import styled from "styled-components";

export const NavBar = styled.div`
  height: 90px;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  /* display: grid;
  grid-template-columns: 0.5fr 1fr 0.5fr; */
  display: flex;
  justify-content: space-between;
  z-index: 3;
  padding-left: 100px;
  padding-right: 100px;

  @media only screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-left: 20px;
    padding-right: 20px;
  }

  #logoLink {
    padding: 0;
  }

  .logo {
    max-height: 100px;
    width: 220px;
    padding: 14px 0;
  }

  .session-links {
    display: flex;
    justify-content: center;
    align-items: center;

    @media only screen and (max-width: 768px) {
      display: none;
    }
  }

  .active {
    color: var(--bs-danger);
    font-weight: 700;

    svg path {
      fill: var(--bs-danger);
    }
  }

  .user-links {
    display: flex;
    justify-content: start;
    align-items: center;

    svg {
      fill: #393939;
      max-height: 20px;
      padding-right: 5px;
    }

    @media only screen and (max-width: 768px) {
      display: none;
    }
  }

  a {
    text-decoration: none;
    text-align: right;
    color: black;
    font-size: .9em;
    padding: 20px;
  }

  .mobile-nav {
    display: none;
    position: relative;

    @media only screen and (max-width: 768px) {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-grow: 1;
    }
  }

  .mobile-user-links {
    opacity: 0;

    @media only screen and (max-width: 768px) {
      width: 100%;
      background-color: white;
      border: 1px solid var(--bs-danger);
      border-radius: 20px;

      a {
        display: block;
        font-size: 1em;
        padding-top: 10px;
        padding-bottom: 10px;
      }

      svg {
        display: none;
      }
    }
  }

  .show-menu {
    transform: rotate(90deg);
    transition-duration: 0.5s;
  }

  .hide-menu {
    transform: rotate(0deg);
    transition-duration: 0.5s;
  }

  #close-mobile-nav {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    visibility: hidden;
    opacity: 0;
    transition: all 0.8s ease-out;
  }

  #open-mobile-nav {
    background-color: white;
    position: absolute;
    visibility: visible;
    top: 100px;
    left: 0;
    right: 0;
    opacity: 1;
    transition: all 0.8s ease-in-out;
    box-shadow: 0px 1px 20px 0px #0ff;
  }
`;
